import { Dashboard } from "@/model/data/dashboard/Dashboard";

export class DashboardState {
    dashboards: Dashboard[] = [];
    editModeEnabled: Boolean = false;
    constructor() {}
}

export default new DashboardState();
